module.exports = __webpack_public_path__ + "img/battery.47a3367d.png";